var LGFG = LGFG || {};
LGFG.CP = LGFG.CP || {};

LGFG.CP.LoadingOverlay = LGFG.CP.LoadingOverlay || (function() {

	// Define settings defaults
	var queue = [];

    var add = function (codename) {
        queue.push(codename);
        $('.loading-overlay').show();
    };

    var remove = function (codename) {
        queue = queue.filter(a => a !== codename);
        if (queue.length === 0) {
            $('.loading-overlay').hide();
        }
    };

    return {
        add: add,
        remove: remove,
        queue: queue
    };
})();